import { configureStore } from '@reduxjs/toolkit';
import authSlice from './auth.slice';
import listSlice from './list.slice';
import templateSlice from './template.slice';
import inventorySlice from './inventory.slice';
import documentSlice from './document.slice';
import credentialSlice from './credential.slice';
import projectSlice from './project.slice';
import dataModelSlice from './dataModel.slice';
import companySlice from './company.slice';
import dashboardSlice from './dashboard.slice';
import configurationSlice from './configuration.slice';
import jobSlice from './job.slice';
import roleSlice from './role.slice';
import userSlice from './user.slice';
import macroSlice from './macro.slice';
import apiTokenSlice from './apiToken.slice';

const store = configureStore({
  reducer: {
    auth: authSlice,
    list: listSlice,
    template: templateSlice,
    dataModel: dataModelSlice,
    inventory: inventorySlice,
    document: documentSlice,
    credential: credentialSlice,
    project: projectSlice,
    company: companySlice,
    dashboard: dashboardSlice,
    configuration: configurationSlice,
    job: jobSlice,
    role: roleSlice,
    userManager: userSlice,
    macro: macroSlice,
    apiToken: apiTokenSlice,
  },
});

export default store;
